export const deviceOs = {
  windowsPhone: 'Windows Phone',
  android: 'Android',
  ios: 'iOS',
};
